module.exports = __webpack_public_path__ + "static/media/avatar.b570fec2.png";